import type { ChatDashboardFilters } from '@if/core/types'
import { useCallback, useState } from 'react'

const STORAGE_KEY = 'chat-dashboard-filters'

export function usePersistedFilters(
  defaults: ChatDashboardFilters,
): [ChatDashboardFilters, React.Dispatch<React.SetStateAction<ChatDashboardFilters>>] {
  const [filters, setFiltersState] = useState<ChatDashboardFilters>(() => {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY)
      if (stored) {
        const parsed = JSON.parse(stored) as Partial<ChatDashboardFilters>
        return { ...defaults, ...parsed, searchTerm: undefined }
      }
    } catch {
      // sessionStorage unavailable or corrupt — use defaults
    }
    return defaults
  })

  const setFilters: React.Dispatch<React.SetStateAction<ChatDashboardFilters>> = useCallback(
    (action) => {
      setFiltersState((prev) => {
        const next = typeof action === 'function' ? action(prev) : action
        try {
          const { searchTerm: _, ...toPersist } = next
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(toPersist))
        } catch {
          // ignore write failures
        }
        return next
      })
    },
    [],
  )

  return [filters, setFilters]
}
